import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LOADING_GIF = "https://customer-assets-0z36b82j.emergentagent.net/job_6374765b-0927-4fa7-ace6-9a95eb25e587/artifacts/6cbu7wu9_LOADING.gif";

export const FunnyLoader = ({ className = "" }) => (
  <div className={`flex items-center justify-center ${className}`} data-testid="site-loader">
    <img src={LOADING_GIF} alt="Cargando..." className="w-48 h-auto" />
  </div>
);

// Hook para obtener frases de estado vacío
export const useEmptyPhrases = () => {
  const [phrases, setPhrases] = useState([
    "Aquí no hay nada... como tu refrigerador a fin de quincena 🥲",
    "Vacío como las promesas de año nuevo",
    "Nada que ver aquí... literalmente",
    "¿Buscas contenido? Pues no hay, sorry not sorry",
    "Esto está más solo que el último churro de la bolsa",
  ]);

  useEffect(() => {
    const fetchPhrases = async () => {
      try {
        const res = await axios.get(`${API}/phrases?phrase_type=empty&active_only=true`);
        if (res.data && res.data.length > 0) {
          setPhrases(res.data.map(p => p.text));
        }
      } catch (error) {
        // Use default phrases if API fails
      }
    };
    fetchPhrases();
  }, []);

  const getRandomPhrase = () => phrases[Math.floor(Math.random() * phrases.length)];

  return { phrases, getRandomPhrase };
};

// Skeleton con estilo divertido
export const FunnySkeleton = ({ className = "" }) => {
  return (
    <div className={`animate-pulse ${className}`}>
      <div className="bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded-xl h-full w-full" 
           style={{ backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
    </div>
  );
};
